import slugify from 'slugify';

const getAnchor = (title) => {
  const anchor = title
    .replace(/[^a-zA-Z0-9 -]+/g, '')
    .trim();

  return slugify(anchor, { lower: true });
};

export {
  getAnchor
};
